import React, { useState } from "react";
import { api } from "@/lib/api";
import { Mail, MapPin, Clock } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await api.post("/contact", form);
      setStatus("success");
      setForm({ name: "", email: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="container-lookers py-16" data-testid="contact-page">
      <h1 className="font-heading font-semibold uppercase text-4xl sm:text-5xl text-zinc-950 mb-3">
        Get In Touch
      </h1>
      <p className="text-sm text-zinc-500 max-w-lg mb-12">Questions about an order, a frame, or selling your own designer glasses? We'd love to hear from you.</p>

      <div className="grid lg:grid-cols-2 gap-12">
        <div className="space-y-6">
          <div className="flex items-start gap-3" data-testid="contact-email-info">
            <Mail size={18} className="text-teal-600 mt-0.5 shrink-0" />
            <div>
              <div className="font-heading font-bold text-sm uppercase text-zinc-950">Email</div>
              <a href="mailto:hello@lookers.com.au" className="text-sm text-zinc-500 hover:text-teal-700 transition-colors">hello@lookers.com.au</a>
            </div>
          </div>
          <div className="flex items-start gap-3" data-testid="contact-location-info">
            <MapPin size={18} className="text-teal-600 mt-0.5 shrink-0" />
            <div>
              <div className="font-heading font-bold text-sm uppercase text-zinc-950">Based In</div>
              <p className="text-sm text-zinc-500">Perth, Western Australia</p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-testid="contact-hours-info">
            <Clock size={18} className="text-teal-600 mt-0.5 shrink-0" />
            <div>
              <div className="font-heading font-bold text-sm uppercase text-zinc-950">Response Time</div>
              <p className="text-sm text-zinc-500">We reply to every message within 1-2 business days.</p>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
          <input
            required
            placeholder="Your name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full bg-white border border-zinc-200 px-3 py-3 text-sm text-zinc-900 placeholder:text-zinc-400 rounded-sm focus:border-teal-600 outline-none"
            data-testid="contact-name-input"
          />
          <input
            required
            type="email"
            placeholder="Your email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full bg-white border border-zinc-200 px-3 py-3 text-sm text-zinc-900 placeholder:text-zinc-400 rounded-sm focus:border-teal-600 outline-none"
            data-testid="contact-email-input"
          />
          <textarea
            required
            rows={5}
            placeholder="How can we help?"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="w-full bg-white border border-zinc-200 px-3 py-3 text-sm text-zinc-900 placeholder:text-zinc-400 rounded-sm focus:border-teal-600 outline-none resize-none"
            data-testid="contact-message-input"
          />
          <button type="submit" disabled={status === "loading"} className="bg-teal-600 hover:bg-charcoal text-white font-heading font-bold text-xs uppercase tracking-wide px-8 py-3.5 transition-colors disabled:opacity-50" data-testid="contact-submit-button">
            {status === "loading" ? "Sending…" : "Send Message"}
          </button>
          {status === "success" && <p className="text-sm text-teal-700" data-testid="contact-success">Thanks — we'll be in touch shortly.</p>}
          {status === "error" && <p className="text-sm text-destructive" data-testid="contact-error">Something went wrong — please try again.</p>}
        </form>
      </div>
    </div>
  );
}
